import { ChangeEvent, useState } from 'react'

export const useInput = (initialValue: string | boolean | undefined) => {
  const [value, setValue] = useState(initialValue)
  const [error, setError] = useState('')

  return {
    value,
    setValue,
    reset: () => setValue(''),
    bind: {
      value,
      onChange: (event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value)
      },
    },
    error,
    setError,
  }
}
